module.exports = __webpack_public_path__ + "static/media/iconMessages.a6d0d0fe.svg";